import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { TYPESENSE_SERVER_CONFIG } from "@/utils/search/clientConfig";

const blogTypesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: TYPESENSE_SERVER_CONFIG,
  additionalSearchParameters: {
    query_by: "title",
    // numTypos: 1,
    // typoTokensThreshold: 1,
  },
});

export const {
  searchClient: blogSearchClient,
  typesenseClient: blogSearchTypesenseClient,
} = blogTypesenseInstantsearchAdapter;
